define('lq/events/actions/thirdPartyAccessRequestCommand',[
    'underscore',
    'lq',
    'lq/events/actions/eventAction',
    'lq/runtimeLocation'
], function (_, lq, EventAction, runtimeLocation) {
    'use strict';

    function ThirdPartyAccessRequestCommand(eventData, eventArg) {
        EventAction.call(this, eventData, eventArg);
        return this;
    }

    EventAction.extend(ThirdPartyAccessRequestCommand, EventAction);

    ThirdPartyAccessRequestCommand.typeName = 'ThirdPartyAccessRequestCommand';

    ThirdPartyAccessRequestCommand.prototype.getBatchType = function () {
        return EventAction.DO_NOT_BATCH;
    };

    ThirdPartyAccessRequestCommand.prototype.execute = function (continuation, eventActionResponse) {
        var url = lq.getTenantUrl('FederatedLogin/RequestAccess'
            + '?actionId=' + encodeURIComponent(this.piping.actionId)
            + '&commandId=' + encodeURIComponent(this.eventData.command)
            + '&parameters=' + encodeURIComponent(JSON.stringify(this.piping.parameters.getNonSystemParameters()))
            + '&returnUrl=' + encodeURIComponent(runtimeLocation.getPathAndSearch()));

        window.location.href = url;
    };

    ThirdPartyAccessRequestCommand.prototype.handleError = function (eventName, defaultMessage, continuation, eventArg) {
        if (this.eventIsEnabled(eventName)) {
            this.triggerEvent(eventName, continuation, eventArg);
        } else {
            alert(defaultMessage);
            continuation();
        }
    };

    return ThirdPartyAccessRequestCommand;
});

